export default "__VITE_PUBLIC_ASSET__1ed37a83__"